export const SETMODULELIST = "SETMODULELIST";
export const SETREPORTSLIST = "SETREPORTSLIST";
export const SETDYNAMICDROPDOWNLIST = "SETDYNAMICDROPDOWNLIST";
export const SETREPORTPARAMS = "SETREPORTPARAMS";
export const SETREPORTOUTPUT = "SETREPORTOUTPUT";
export const SETREPORTAUTHORIZATION = "SETREPORTAUTHORIZATION";